import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizableBodyInterface } from '@sport-activities/sdk';

import { buildLocatableBody } from '~/organizer/shared/helpers/locatable/build-locatable-body/build-locatable-body.helper';

@Injectable({
  providedIn: 'root',
})
export class OrganizerSharedLocatableService {
  constructor(private readonly translateService: TranslateService) {}

  public buildCurrentLocatableBody<T>(value: T): LocalizableBodyInterface<T> {
    return buildLocatableBody<T>(this.translateService.currentLang, value);
  }
}
